import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function RequireAuth({ children, role }) {
  const { loading, isAuthenticated, user, isAdmin, isDevMode, emailVerified } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Loading…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Firebase production: block instructor/admin areas until email is verified
  if (
    !isDevMode &&
    !emailVerified &&
    location.pathname !== "/verify-email" &&
    !location.pathname.startsWith("/verify-email")
  ) {
    return <Navigate to="/verify-email" replace />;
  }

  if (role === "admin" && !isAdmin) {
    return <Navigate to="/instructor" replace />;
  }

  if (role === "instructor" && user && user.role === "admin") {
    // Admins can still access instructor area
  }

  if (role === "partner" && user && user.role !== "partner" && user.role !== "admin") {
    return <Navigate to="/partner" replace />;
  }

  return children;
}
